import PropTypes from 'prop-types';
import { forwardRef, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import SelectActionButton from 'Components/Atoms/Select/SelectActionButton';
import OutlineAdd from 'Components/Atoms/OutlineIcons/OutlineAdd';
import MultiselectTaxesMultiple from './MultiselectTaxesMultiple';
import useInvoiceTaxes from 'Hooks/useInvoiceTaxes';

const MultiselectTaxes = forwardRef(function MultiselectTags(props, ref) {
    const { onAdd, value, ...selectProps } = props;

    const { t } = useTranslation('taxes');
    const { invoiceTaxes, isLoading } = useInvoiceTaxes(value);

    const actions = useMemo(() => {
        if (!onAdd) return [];
        return [
            <SelectActionButton icon={<OutlineAdd size={18} />} key="action-add-tag" onClick={() => onAdd()}>
                {t('add-category')}
            </SelectActionButton>,
        ];
    }, [onAdd, t]);

    if (isLoading) return <div className="h-11" />;

    return <MultiselectTaxesMultiple actions={actions} taxes={invoiceTaxes} ref={ref} value={value} {...selectProps} />;
});

export default MultiselectTaxes;

MultiselectTaxes.propTypes = {
    disabled: PropTypes.bool,
    value: PropTypes.arrayOf(PropTypes.string),
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string,
    className: PropTypes.string,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    highlight: PropTypes.bool,
    onAdd: PropTypes.func,
};
